import { render, staticRenderFns } from "./CustomerCare.vue?vue&type=template&id=268fe9d0&scoped=true"
import script from "./CustomerCare.vue?vue&type=script&lang=js"
export * from "./CustomerCare.vue?vue&type=script&lang=js"
import style0 from "./CustomerCare.vue?vue&type=style&index=0&id=268fe9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268fe9d0",
  null
  
)

export default component.exports